// extracted by mini-css-extract-plugin
export var addToCartWrapper = "_wg-8";
export var editMode = "_wg-3";
export var headerRow = "_wg-a";
export var headerTitle = "_wg-b";
export var product = "_wg-1";
export var productDetails = "_wg-5";
export var productDivider = "_wg-7";
export var productImage = "_wg-2";
export var productInfo = "_wg-4";
export var productTitle = "_wg-6";
export var strikethrough = "_wg-9";
export var upsellProductsCard = "_wg-0";